import { Component, ViewChild, ElementRef } from '@angular/core'
import { InputBaseComponent } from '../input-base.component';

@Component({
  selector: 'ct-input-checkbox',
  templateUrl: './ct-input-checkbox.component.html',
  styleUrls: ['./ct-input-checkbox.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()'
  }
})
export class CtInputCheckBoxComponent extends InputBaseComponent {
  @ViewChild('el') formControl: ElementRef;
  
  private trueValue: string;
  private falseValue: string;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    this.setInitValue((this.getValue() === this.trueValue) ? true : false);
  }

  getTrueValue(): string { return this.trueValue }
  getFalseValue(): string { return this.falseValue }
  getFormControl(): any { return this.formControl }
  getValue(): string {
    if (super.getValue())
      return this.trueValue;
    return this.falseValue;
  }

  setTrueValue(trueValue: string): void { this.trueValue = trueValue }
  setFalseValue(falseValue: string): void { this.falseValue = falseValue }
  setValue(value: any): void { 
    if (typeof(value) === 'string')
      super.setValue(value === this.getTrueValue());
    else
      super.setValue(value);
  }
}

